const submitFormData = async (formData, endpoint) => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      if (response.status === 400) {
        const errorData = await response.json();
        console.error('Bad Request:', errorData);
        throw new Error('Bad Request: Please check your input.');
      } else {
        console.error('Error submitting form data:', response.statusText);
        throw new Error('There was a problem with your submission. Please try again.');
      }
    }

    return await response.json();
  } catch (error) {
    console.error('Error submitting form data:', error);
    throw error;
  }
};

module.exports = {
  submitFormData
};
